import { axiosRequest } from "../axios.config";

const enrollmentApi = {
  checkEnrollment: async (courseId) => {
    const url = "Enrollment/check-enrollment";
    const config = { params: { courseId } };
    const response = await axiosRequest.get(url, config);
    return response;
  },
  enroll: async (courseId) => {
    const url = `Enrollment?courseId=${courseId}`;
    const response = await axiosRequest.post(url, null);
    return response;
  },
  myTotalEnrollment: async () => {
    const url = "Enrollment/Get-total-enroll-of-user";
    const response = await axiosRequest.get(url);
    return response;
  },
  getTotalEnrollInstructor: async (params) => {
    const url = "Enrollment/Get-total-enroll-of-instructor";
    const response = await axiosRequest.get(url, { params });
    return response;
  },
};

export { enrollmentApi };
